import '../Home.css';
import stars from '../assets/images/stars.jpg';
import gameplay from '../assets/videos/d2shatterskating.mp4'
const Home = () => {
    return (
        <div id="body" bg="dark" data-bs-theme="dark">
            <div id="homebar">
                <header id="welcome">
                    <h3>WELCOME!</h3>
                </header>
            </div>
            <div id="contentsection1">
                <div className="desc">
                    Hi there! I am compscichris. I am a graduate from the University 
                    of Arizona with a bachelor's degree, and currently working on my 
                    MS in CS at California State University Chico. I created this 
                    website as an introduction, and a demonstration of my technical 
                    skills in full-stack web development. This website was built on a
                    Django React stack, and is hosted on AWS. 
                </div>    
            </div>
            <div id="contentsection2">
                <div className="centering">
                    <div className="desc">
                        Last update: 9.13.2026
                        Features: Django React stack
                        Notes: Needs stylesheet reorganization
                    </div>
                    
                </div>
                <div className="centering">
                    <video width="480" height="270" controls>
                    <source src={gameplay} type="video/mp4"/>
                    Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    )
};

export default Home;